import { render, staticRenderFns } from "./Progress.vue?vue&type=template&id=0484c805"
import script from "./Progress.vue?vue&type=script&lang=ts"
export * from "./Progress.vue?vue&type=script&lang=ts"
import style0 from "./Progress.vue?vue&type=style&index=0&id=0484c805&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports